/**
 * Network Status Type Definitions
 * These types match the Rust models in arbi-common/src/models/network_status.rs
 */

export type Congestion = 'Unknown' | 'Busy' | 'Free';

export interface CryptoNetwork {
  network: string;           // Standardized network symbol (e.g., "BTC", "ETH", "BSC", "TRX")
  name: string;              // Exchange's original network name (e.g., "Bitcoin", "Ethereum (ERC20)")
  deposit_enabled: boolean;
  withdraw_enabled: boolean;
  contract_address?: string; // Optional: Contract address for tokens
  min_deposit?: number;
  min_withdraw?: number;
  withdraw_fee?: number;
  congestion?: Congestion;  // Network congestion status
  estimated_arrival_time?: number; // Optional: Estimated arrival time in minutes
  confirmations?: number;    // Optional: Confirmations required
}

export interface Crypto {
  symbol: string;            // "BTC", "ETH", "USDT"
  name: string;              // "Bitcoin", "Ethereum"
  networks: CryptoNetwork[];
}

export interface NetworkStatusResponse {
  exchange: number;  // Exchange index (0-10)
  cryptos: Crypto[];
  timestamp: number;
}

// Use array for direct numeric indexing (exchanges 0-11)
export type NetworkStatusData = (NetworkStatusResponse | undefined)[];

export interface StoredNetworkStatus {
  id: string;
  data: NetworkStatusData;
  timestamp: number;
  version: number;
}

export interface NetworkStatusState {
  data: NetworkStatusData;
  loading: { [exchange: number]: boolean };
  error: { [exchange: number]: string | null };
  lastFetchTime: { [exchange: number]: number };
  autoRefreshEnabled: boolean;
}

// Exchange indices matching Rust enum (0-11)
export const EXCHANGE_INDICES = {
  Upbit: 0,
  Bithumb: 1,
  Coinone: 2,
  Binance: 3,
  HTX: 4,
  GateIO: 5,
  KuCoin: 6,
  OKX: 7,
  MEXC: 8,
  Bybit: 9,
  Bitget: 10,
  Coinbase: 11,
} as const;

export const ALL_EXCHANGE_INDICES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] as const;